import { useEffect, useState } from "react";
import { Landmark, RefreshCcw } from "lucide-react";
import { api, rupiah } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { PortalOrdersPanel } from "../components/PortalOrdersPanel";
import { DatePicker } from "../components/DatePicker";

function Stat({ label, value, sub, color, testid }) {
  return (
    <div className="rounded-xl border border-border bg-card px-4 py-3" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className={`font-heading font-bold text-xl ${color}`}>{value}</div>
      {sub && <div className="text-[11px] text-muted-foreground">{sub}</div>}
    </div>
  );
}

export default function PembayaranPortal() {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [tick, setTick] = useState(0);
  const loadAll = () => api.get("/portal-orders", { params: { status: "all" } }).then((r) => setAll(r.data)).catch(() => {});
  useEffect(() => { loadAll(); const t = setInterval(loadAll, 30000); return () => clearInterval(t); }, [tick]);
  const inRange = all.filter((o) => (!from || o.created_at >= from) && (!to || o.created_at <= to + "T23:59:59"));
  const n = (st) => inRange.filter((o) => o.status === st);
  const today = new Date().toISOString().slice(0, 10);
  const lunasToday = all.filter((o) => o.status === "lunas" && (o.confirmed_at || "").startsWith(today));
  return (
    <div className="space-y-5" data-testid="pembayaran-portal-page">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2"><Landmark className="w-7 h-7 text-sky-500" /> Pembayaran Portal</h1>
          <p className="text-sm text-muted-foreground mt-1">Konsumen yang membayar lewat <span className="font-mono">billing.fasnetfiber.com/portal</span> (transfer BCA). Cek status bayar, bukti transfer, lalu konfirmasi.</p>
        </div>
        <div className="flex gap-2 flex-wrap items-center">
          <DatePicker value={from} onChange={(v) => setFrom(v)} className="h-9 w-36 text-xs" testid="pp-from" />
          <DatePicker value={to} onChange={(v) => setTo(v)} className="h-9 w-36 text-xs" testid="pp-to" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari secret / cabang / nominal..." className="h-9 w-56 text-xs" data-testid="pp-search" />
          <Button variant="outline" size="sm" className="h-9" onClick={() => setTick((t) => t + 1)} data-testid="pp-refresh"><RefreshCcw className="w-4 h-4" /></Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        <Stat label="Menunggu Konfirmasi" value={n("menunggu").length} sub={`${n("menunggu").filter((o) => o.has_proof).length} sudah kirim bukti`} color="text-amber-500" testid="pp-stat-menunggu" />
        <Stat label="Lunas" value={n("lunas").length} sub={rupiah(n("lunas").reduce((a, o) => a + (o.amount_pay || 0), 0))} color="text-emerald-500" testid="pp-stat-lunas" />
        <Stat label="Lunas Hari Ini" value={lunasToday.length} sub={rupiah(lunasToday.reduce((a, o) => a + (o.amount_pay || 0), 0))} color="text-emerald-500" testid="pp-stat-today" />
        <Stat label="Ditolak" value={n("ditolak").length} color="text-rose-500" testid="pp-stat-ditolak" />
        <Stat label="Kedaluwarsa" value={n("kedaluwarsa").length} sub="tanpa bukti > 10 menit" color="text-muted-foreground" testid="pp-stat-kedaluwarsa" />
      </div>
      <div className="rounded-xl border border-border bg-card p-3 space-y-3">
        <PortalOrdersPanel key={tick} onChanged={loadAll} search={q} dateFrom={from} dateTo={to} />
      </div>
    </div>
  );
}
